import config from "config";
/**
 *
 * @returns base host for api requests
 */
export function resolveApiHostBase() {
  return process.env.API_HOST_BASE;
}

export function isServer() {
  return typeof window === "undefined";
}

/**
 *
 * @returns true if env is development
 */
export function isDev() {
  return (
    process.env.NODE_ENV?.toLowerCase() === "development" ||
    process.env.APP_ENV?.toLowerCase() === "development"
  );
}

export function sortByAccountName(a, b) {
  return a.account.name.localeCompare(b.account.name);
}

export function sortBySlug(a, b) {
  return a.slug.localeCompare(b.slug);
}

export function sortByName(a, b) {
  return a.name.localeCompare(b.name);
}

export function getStatus(error): number {
  return error.response.status || 500;
}

export const getUniqueChildCategories = (categories) => {
  if (!Array.isArray(categories)) return [];
  const children = categories.map((c) => c.children).flat();
  const uniques = children
    .map((child) => ({ name: child.name, slug: child.slug }))
    .reduce((p, c) => {
      return { ...p, [c.slug]: c.name };
    }, {});

  // Convert back to array
  return Object.entries(uniques).map((u) => ({ slug: u[0], name: u[1] }));
};

export const withImageResizer = (
  imgPath: string,
  width: number,
  q: number = 75
) => {
  let pathname = imgPath;
  if (pathname.startsWith("http")) {
    const u = new URL(pathname);
    pathname = u.pathname;
  }

  if (!pathname.startsWith("/")) {
    pathname = "/" + pathname;
  }
  return config.imgResizer + `/${width}x,q${q},jpeg${pathname}`;
};
